var _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Paint_Palette_48",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    stroke: "none",
    fill: "#000000",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.92 0 0 0.92 24 24)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_zw4GiaScaR0Wz5L8PhjEXa_1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 10.645,
    y1: 11.8,
    x2: 38.25,
    y2: 36.027
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(59,201,243)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "24.3%",
    style: {
      stopColor: "rgb(55,195,240)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "58.4%",
    style: {
      stopColor: "rgb(42,176,231)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "97.89999999999999%",
    style: {
      stopColor: "rgb(22,147,217)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(21,145,216)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_zw4GiaScaR0Wz5L8PhjEXa_1)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-24, -24)",
    d: "M 28 4 C 12 4 4 18.559 4 28 C 4 36.182 7 38 9.23 38 C 13.530000000000001 38 15.565000000000001 31 19 31 C 20.533 31 22 32.076 22 34 C 22 36.671 19 36.753 19 40.389 C 19 41.72 20.37 44 23.332 44 C 31.792 44 44 34 44 20.5 C 44 8.145 35 4 28 4 z M 25.5 29 C 24.119 29 23 27.881 23 26.5 C 23 25.119 24.119 24 25.5 24 C 26.881 24 28 25.119 28 26.5 C 28 27.881 26.881 29 25.5 29 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -8.5 -6.5)"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_zw4GiaScaR0Wz5L8PhjEXb_2",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -15.5 -17.5)",
    cx: 15.5,
    cy: 17.5,
    r: 4.5,
    fx: 15.5,
    fy: 17.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(0,0,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(0,0,0)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_zw4GiaScaR0Wz5L8PhjEXb_2)",
      fillRule: "nonzero",
      opacity: 0.15
    },
    cx: 0,
    cy: 0,
    r: 4.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -13.5 2.5)"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_zw4GiaScaR0Wz5L8PhjEXc_3",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -10.5 -26.5)",
    cx: 10.5,
    cy: 26.5,
    r: 4.5,
    fx: 10.5,
    fy: 26.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(0,0,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(0,0,0)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_zw4GiaScaR0Wz5L8PhjEXc_3)",
      fillRule: "nonzero",
      opacity: 0.15
    },
    cx: 0,
    cy: 0,
    r: 4.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -8.5 -7.5)"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_zw4GiaScaR0Wz5L8PhjEXd_4",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -15.5 -16.5)",
    cx: 13.51,
    cy: 13.722,
    r: 6.873,
    fx: 13.51,
    fy: 13.722
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(254,225,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(247,165,17)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_zw4GiaScaR0Wz5L8PhjEXd_4)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.5 -11.5)"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_zw4GiaScaR0Wz5L8PhjEXe_5",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -24.5 -12.5)",
    cx: 24.5,
    cy: 12.5,
    r: 4.5,
    fx: 24.5,
    fy: 12.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(0,0,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(0,0,0)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_zw4GiaScaR0Wz5L8PhjEXe_5)",
      fillRule: "nonzero",
      opacity: 0.15
    },
    cx: 0,
    cy: 0,
    r: 4.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.5 -12.5)"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_zw4GiaScaR0Wz5L8PhjEXf_6",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -24.5 -11.5)",
    cx: 22.715,
    cy: 8.859,
    r: 6.758,
    fx: 22.715,
    fy: 8.859
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(166,255,110)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(41,205,47)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_zw4GiaScaR0Wz5L8PhjEXf_6)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 10.5 -9.5)"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_zw4GiaScaR0Wz5L8PhjEXg_7",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -34.5 -14.5)",
    cx: 34.5,
    cy: 14.5,
    r: 4.5,
    fx: 34.5,
    fy: 14.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(0,0,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(0,0,0)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_zw4GiaScaR0Wz5L8PhjEXg_7)",
      fillRule: "nonzero",
      opacity: 0.15
    },
    cx: 0,
    cy: 0,
    r: 4.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 10.5 -10.5)"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_zw4GiaScaR0Wz5L8PhjEXh_8",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -34.5 -13.5)",
    cx: 32.715,
    cy: 10.859,
    r: 6.758,
    fx: 32.715,
    fy: 10.859
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(66,164,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(22,69,171)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_zw4GiaScaR0Wz5L8PhjEXh_8)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 13.5 0.5)"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_zw4GiaScaR0Wz5L8PhjEXi_9",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -37.5 -24.5)",
    cx: 37.5,
    cy: 24.5,
    r: 4.5,
    fx: 37.5,
    fy: 24.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(0,0,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(0,0,0)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_zw4GiaScaR0Wz5L8PhjEXi_9)",
      fillRule: "nonzero",
      opacity: 0.15
    },
    cx: 0,
    cy: 0,
    r: 4.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 13.5 -0.5)"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_zw4GiaScaR0Wz5L8PhjEXj_10",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -37.5 -23.5)",
    cx: 35.715,
    cy: 20.859,
    r: 6.758,
    fx: 35.715,
    fy: 20.859
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(152,110,224)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(99,71,150)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_zw4GiaScaR0Wz5L8PhjEXj_10)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -13.5 1.5)"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_zw4GiaScaR0Wz5L8PhjEXk_11",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -10.5 -25.5)",
    cx: 8.46,
    cy: 22.546,
    r: 6.755,
    fx: 8.46,
    fy: 22.546
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(232,81,130)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(208,55,103)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_zw4GiaScaR0Wz5L8PhjEXk_11)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 3.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaint);
export default __webpack_public_path__ + "static/media/paint.9d0089e5a55d59ccc7bacb04476e0ce7.svg";
export { ForwardRef as ReactComponent };